// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submit } from 'redux-form'

class Submit extends React.Component {
  static propTypes = {
    idRoot: string.isRequired,
    sourceForm: string.isRequired,
    submit: func.isRequired,
  }

  // Because this set can be used within a Path Details form for PPL,
  // and because react-modal has a bug: https://github.com/reactjs/react-modal/issues/558
  // the submit Event from this form can bubble up to the Path Details form, triggering a
  // submit in both places. To work around this, take the click event, preventDefault
  // then call the submit thunk to trigger its submit handler.
  handleClick = e => {
    e.preventDefault()

    const {
      sourceForm,
      submit,
    } = this.props

    return submit(sourceForm)
  }

  render () {
    return (
      <button
        className={'btn search-button big-button'}
        id={`${this.props.idRoot}submit`}
        onClick={this.handleClick}
        type={'submit'}>
        {'search'}
      </button>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    submit,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(Submit)
